module.exports = __webpack_public_path__ + "img/feedback-product03-img1.7b5b2b53.png";